import { Tag } from '@/types';

export const filterHiddenTags = (tags: Tag[]) => tags.filter((tag) => tag.Visibility);
